"use strict";

require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _layout = require("@citrus/layout");
var _icon = require("@citrus/icon");
var _button = require("@citrus/button");
var _PctyQuestionBuilderEdit = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.PageManagerButton"));
var _modal = require("@citrus/modal");
var _p, _Icon, _Icon2, _Icon3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PctyQuestionBuilderEditPageManager = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionBuilderEditPageManager, _Component);
  var _super = _createSuper(PctyQuestionBuilderEditPageManager);
  function PctyQuestionBuilderEditPageManager(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionBuilderEditPageManager);
    _this = _super.call(this, props);
    _this.state = {
      showRemoveModal: false,
      pageToDelete: null,
      firstVisiblePageIndex: 0
    };
    _this.onClickConfirmRemove = _this.onClickConfirmRemove.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCancelRemove = _this.onCancelRemove.bind((0, _assertThisInitialized2.default)(_this));
    _this.onPreviousPage = _this.onPreviousPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.onNextPage = _this.onNextPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.onNewPage = _this.onNewPage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionBuilderEditPageManager, [{
    key: "onClickRemovePage",
    value: function onClickRemovePage(id) {
      this.setState({
        pageToDelete: id,
        showRemoveModal: true
      });
    }
  }, {
    key: "onCancelRemove",
    value: function onCancelRemove() {
      this.setState({
        pageToDelete: null,
        showRemoveModal: false
      });
    }
  }, {
    key: "onClickConfirmRemove",
    value: function onClickConfirmRemove() {
      var minPageIndex = this.state.firstVisiblePageIndex;
      var maxPageIndex = this.state.firstVisiblePageIndex + this.props.scrollAfterPages;

      // decrement the firstVisiblePageIndex if they're deleting pages from the back of the stack
      if (minPageIndex > 0 && this.props.pages.length >= this.props.scrollAfterPages) {
        if (maxPageIndex - minPageIndex >= this.props.scrollAfterPages) minPageIndex--;
      }
      var id = this.state.pageToDelete;
      this.setState({
        pageToDelete: null,
        showRemoveModal: false,
        firstVisiblePageIndex: minPageIndex
      });
      this.props.deletePage(id);
    }
  }, {
    key: "onPreviousPage",
    value: function onPreviousPage() {
      var firstVisiblePageIndex = this.state.firstVisiblePageIndex > 0 ? this.state.firstVisiblePageIndex - 1 : this.state.firstVisiblePageIndex;
      this.setState({
        firstVisiblePageIndex: firstVisiblePageIndex
      });
    }
  }, {
    key: "onNextPage",
    value: function onNextPage() {
      var firstVisiblePageIndex = this.state.firstVisiblePageIndex + this.props.scrollAfterPages < this.props.pages.length ? this.state.firstVisiblePageIndex + 1 : this.state.firstVisiblePageIndex;
      this.setState({
        firstVisiblePageIndex: firstVisiblePageIndex
      });
    }
  }, {
    key: "onNewPage",
    value: function onNewPage() {
      this.props.addNewPage();
      var nextPageVisible = this.state.firstVisiblePageIndex + this.props.scrollAfterPages < this.props.activePageIndex + 1;
      if (!nextPageVisible) {
        var firstVisiblePageIndex = this.state.firstVisiblePageIndex + this.props.scrollAfterPages < this.props.pages.length + 1 ? this.state.firstVisiblePageIndex + 1 : this.state.firstVisiblePageIndex;
        this.setState({
          firstVisiblePageIndex: firstVisiblePageIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_modal.Modal, {
        headerText: "Confirm Delete",
        id: "remove-page-modal",
        onCancel: function onCancel() {
          return _this2.onCancelRemove();
        },
        open: this.state.showRemoveModal,
        size: "small"
      }, _p || (_p = /*#__PURE__*/_react.default.createElement("p", null, "Are you sure you want to delete this page? All content on this page will be deleted.")), /*#__PURE__*/_react.default.createElement(_modal.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
        onClick: this.onClickConfirmRemove
      }, "Delete Page"), /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
        "data-dismiss": "modal",
        onClick: this.onCancelRemove,
        type: "outline"
      }, "Cancel"))), this.renderPages());
    }
  }, {
    key: "renderPages",
    value: function renderPages() {
      var _this3 = this;
      var showScrollers = this.props.pages.length >= this.props.scrollAfterPages;
      var minPageIndex = this.state.firstVisiblePageIndex;
      var maxPageIndex = this.state.firstVisiblePageIndex + this.props.scrollAfterPages;
      return /*#__PURE__*/_react.default.createElement(_layout.Row, null, /*#__PURE__*/_react.default.createElement(_layout.Col, null, showScrollers && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
        className: "page-scroller-arrow left",
        disabled: this.props.disabled || minPageIndex === 0,
        id: "previous-page-arrow",
        onClick: this.onPreviousPage
      }, _Icon || (_Icon = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
        name: "chevron-left",
        title: "Previous Page"
      }))), this.props.pages.map(function (item, index) {
        return index >= minPageIndex && index < maxPageIndex && /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit.default, {
          pageNumber: index + 1,
          id: item.key,
          key: item.key,
          disabled: _this3.props.disabled,
          allowDelete: _this3.props.pages.length > 1,
          isActive: index === _this3.props.activePageIndex,
          onClickDuplicatePage: function onClickDuplicatePage(id) {
            return _this3.props.duplicatePage(id);
          },
          onClickDeletePage: function onClickDeletePage(id) {
            return _this3.onClickRemovePage(id);
          },
          onClickSelectPage: function onClickSelectPage(id) {
            return _this3.props.setActivePage(id);
          }
        });
      }), showScrollers && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
        className: "page-scroller-arrow right",
        disabled: this.props.disabled || maxPageIndex === this.props.pages.length,
        id: "next-page-arrow",
        onClick: this.onNextPage
      }, _Icon2 || (_Icon2 = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
        name: "chevron-right",
        title: "Next Page"
      })))), /*#__PURE__*/_react.default.createElement(_layout.Col, {
        className: "pcty-align-right pcty-col-2"
      }, /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
        style: {
          minWidth: '125px'
        },
        disabled: this.props.disabled,
        id: "new-page",
        onClick: this.onNewPage
      }, _Icon3 || (_Icon3 = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
        name: "plus",
        title: "New Page"
      })), " New Page")));
    }
  }]);
  return PctyQuestionBuilderEditPageManager;
}(_react.Component);
PctyQuestionBuilderEditPageManager.propTypes = {
  id: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  activePageIndex: _propTypes.default.number.isRequired,
  pages: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired
  })),
  scrollAfterPages: _propTypes.default.number,
  duplicatePage: _propTypes.default.func.isRequired,
  deletePage: _propTypes.default.func.isRequired,
  setActivePage: _propTypes.default.func.isRequired,
  addNewPage: _propTypes.default.func.isRequired
};
PctyQuestionBuilderEditPageManager.defaultProps = {
  disabled: false,
  scrollAfterPages: 7
};
var _default = exports.default = PctyQuestionBuilderEditPageManager;